import { Form, Checkbox, InputNumber, Row, Col, Divider } from "antd";
import React from "react";

/**
 * Optional rate-limit fields shared by the GenAI and ChatCompletion forms.
 * Mirrors the backend `RateLimitConfigMixin`. All fields live under `extra_data`.
 */
const RateLimitFields = () => {
    return (
        <>
            <Divider titlePlacement="start">Rate Limiting</Divider>

            <Row gutter={16}>
                <Col span={12}>
                    <Form.Item
                        label="Token Limit / min"
                        name={["extra_data", "token_limit_1m"]}
                        extra="Max tokens per minute. Leave empty for no limit."
                        rules={[{ type: "number", min: 1, message: "Must be at least 1" }]}
                    >
                        <InputNumber placeholder="No limit" style={{ width: "100%" }} min={1} step={1} />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        label="Requests Limit / min"
                        name={["extra_data", "requests_limit_1m"]}
                        extra="Max requests per minute. Leave empty for no limit."
                        rules={[{ type: "number", min: 1, message: "Must be at least 1" }]}
                    >
                        <InputNumber placeholder="No limit" style={{ width: "100%" }} min={1} step={1} />
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={16}>
                <Col span={12}>
                    <Form.Item
                        label="Token Limit / day"
                        name={["extra_data", "token_limit_1d"]}
                        extra="Max tokens per day. Leave empty for no limit."
                        rules={[{ type: "number", min: 1, message: "Must be at least 1" }]}
                    >
                        <InputNumber placeholder="No limit" style={{ width: "100%" }} min={1} step={1} />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        label="Requests Limit / day"
                        name={["extra_data", "requests_limit_1d"]}
                        extra="Max requests per day. Leave empty for no limit."
                        rules={[{ type: "number", min: 1, message: "Must be at least 1" }]}
                    >
                        <InputNumber placeholder="No limit" style={{ width: "100%" }} min={1} step={1} />
                    </Form.Item>
                </Col>
            </Row>

            <Form.Item
                label="Fail On Rate Limit"
                name={["extra_data", "fail_on_rate_limit"]}
                valuePropName="checked"
            >
                <Checkbox>Reject with HTTP 429 when a limit is reached instead of buffering and retrying</Checkbox>
            </Form.Item>
        </>
    );
};

export default RateLimitFields;
